<div class="dry-ice-quantity" [class.d-none]="!visible">
  <div class="dry-ice-quantity__body">
    <div class="qty d-flex">
      <form [formGroup]="formGroup">
        <input
          #input
          class="custom-input"
          type="text"
          placeholder="Qty"
          [formControlName]="code"
          [(ngModel)]="value"
          (focus)="onFocus.emit()"
          (keypress)="onKeyPress($event)"
          (keydown)="onKeyDown($event)"
          (keyup)="onKeyUp($event)"
          (paste)="onPaste($event)"
        />
      </form>
      <span
        class="dry-ice-tooltip"
        caiPopover
        [target]="dryIceTooltip"
        [allowHoverOnTarget]="true"
        [placement]="'right'"
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.47596 1.5C5.07096 1.5 1.5 5.07096 1.5 9.47596C1.5 13.881 5.07096 17.4519 9.47596 17.4519C13.881 17.4519 17.4519 13.881 17.4519 9.47596C17.4519 5.07096 13.881 1.5 9.47596 1.5ZM0 9.47596C0 4.24253 4.24253 0 9.47596 0C14.7094 0 18.9519 4.24253 18.9519 9.47596C18.9519 14.7094 14.7094 18.9519 9.47596 18.9519C4.24253 18.9519 0 14.7094 0 9.47596ZM9.47595 4.69775C9.97301 4.69775 10.376 5.10069 10.376 5.59775V10.4455C10.376 10.9426 9.97301 11.3455 9.47595 11.3455C8.9789 11.3455 8.57595 10.9426 8.57595 10.4455V5.59775C8.57595 5.10069 8.9789 4.69775 9.47595 4.69775ZM9.65403 14.9965C10.1786 14.9965 10.6038 14.5712 10.6038 14.0467C10.6038 13.5221 10.1786 13.0969 9.65403 13.0969C9.12949 13.0969 8.70427 13.5221 8.70427 14.0467C8.70427 14.5712 9.12949 14.9965 9.65403 14.9965Z"
            fill="#679EC6"
          />
        </svg>
        <ng-template #dryIceTooltip>
          <kt-popover
            [showIcon]="true"
            [width]="295"
            [arrowColor]="'rgba(233, 246, 255, 0.66)'"
            [bgColor]="
              'linear-gradient(262.9deg, #e9f6ff 0.66%, #ffffff 109.77%)'
            "
            placement="right"
            style="max-width: 255px !important"
          >
            <div body class="popover-body">
              <span i18n="@@global.enter-dry-ice-kg"
                >Enter the total quantity of dry ice in Kg for this shipment.
                Note: This weight must be included in the total shipment
                weight.</span
              >
            </div>
          </kt-popover>
        </ng-template>
      </span>
    </div>
  </div>
</div>
